import React from 'react';
import CategoryMapPage from '../../../../CategoryMapPage';
import { headerHeight } from '../../../../../base-styles/vars';

// 68px hides the map bottom footer for now.
const mapStyleDefault = {
  height: `calc(var(--vh, vh) * 100 - ${headerHeight} + 68px)`,
  width: 'calc(100vw - (100vw - 100%))', // full width minus potential scrollbar
};

const FindViewMapMobile = ({
  categoryData,
  searchParams,
  hideEventList,
  dataLoading,
}) => {
  return (
    <>
      <CategoryMapPage
        data={{ categoryData, loading: dataLoading }}
        searchParams={searchParams}
        isExternalMap
        hideBackClick
        hideEventList={hideEventList}
        mapStyle={mapStyleDefault}
      />
    </>
  );
};

export default FindViewMapMobile;
